import React from 'react';
import { Link } from 'react-router-dom';  // Import Link component
import { useTranslation, Trans } from 'react-i18next';  // Import translation hook and Trans component

const TermsOfUse = () => {
  const { t } = useTranslation();  // Get the translation function

  return (
    <div className="terms-of-use">
      <h1>{t('terms_of_use_title')}</h1>
      <p><strong>{t('effective_from')}</strong> 20.01.2025</p>

      <p>{t('terms_intro')}</p>

      <h2>{t('acceptance_of_terms_title')}</h2>
      <p>
        {t('acceptance_of_terms')}
      </p>

      <h2>{t('use_of_website_title')}</h2>
      <p>{t('use_of_website')}</p>

      <h2>{t('intellectual_property_title')}</h2>
      <p>{t('intellectual_property')}</p>

      <h2>{t('limitation_of_liability_title')}</h2>
      <p>{t('limitation_of_liability')}</p>

      <h2>{t('third_party_links_title')}</h2>
      <p>{t('third_party_links')}</p>

      <h2>{t('changes_to_terms_title')}</h2>
      <p>{t('changes_to_terms')}</p>

      <h2>{t('user_conduct_title')}</h2>
      <p>{t('user_conduct_intro')}</p>
      <ul>
        <li>{t('malicious_software')}</li>
        <li>{t('unauthorized_access')}</li>
        <li>{t('intellectual_property_violation')}</li>
      </ul>

      <h2>{t('governing_law_title')}</h2>
      <p>{t('governing_law')}</p>

      <h2>{t('termsofuse_contact_title')}</h2>
      <p>{t('termsofuse_contact_intro')}</p>
      <ul>
        <li><strong>{t('nostr_label')}:</strong> npub17yh89gqvkcck494vag8cwep4ah7g8gwe54ussy4vhltxls8gzc5qwrfek5</li>
      </ul>
    </div>
  );
};

export default TermsOfUse;
